import { z } from 'zod';

export const ErrorCodeSchema = z.enum([
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'GEOMETRY_FORBIDDEN',
  'ENTITY_NOT_IN_SCOPE',
  'NOT_FOUND',
  'VALIDATION_FAILED',
  'CONFLICT',
  'STALE_RECORD',
  'RATE_LIMITED',
  'PAYLOAD_TOO_LARGE',
  'UNSUPPORTED_MEDIA',
  'IMPORT_PARSE_ERROR',
  'GEOJSON_INVALID',
  'FILE_TOO_LARGE',
  'BOOTSTRAP_DISABLED',
  'INACTIVE_USER',
  'LAST_ADMIN',
  'APP_VERSION_DEPRECATED',
  'INTERNAL',
]);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;

export const ErrorDetailSchema = z.object({
  path: z.string(),
  code: z.string(),
  message: z.string(),
});
export type ErrorDetail = z.infer<typeof ErrorDetailSchema>;

export const ErrorResponseSchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    requestId: z.string().optional(),
    details: z.array(ErrorDetailSchema).optional(),
    // Carries the fresh record on 409 STALE_RECORD so the editor can
    // offer a "reload and merge" flow without a separate GET round-trip.
    current: z.unknown().optional(),
    /**
     * Populated only on ENTITY_NOT_IN_SCOPE (403). Lists the entries the
     * caller tried to assign that are not in their own assignedEntitatiSilvice.
     */
    entitiesOutOfScope: z.array(z.string()).optional(),
  }),
});
export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;
